import { render, staticRenderFns } from "./StartProcessButton.vue?vue&type=template&id=9fceae98"
import script from "./StartProcessButton.vue?vue&type=script&lang=js"
export * from "./StartProcessButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports